//국가 코드
const countryCodeName = [
    { label: 'GHA', id: 0 },
    { label: 'GAB', id: 1 },
    { label: 'GUY', id: 2 },
    { label: 'GMB', id: 3 },
    { label: 'GGY', id: 4 },
    { label: 'GLP', id: 5 },
    { label: 'GTM', id: 6 },
    { label: 'GUM', id: 7 },
    { label: 'GRD', id: 8 },
    { label: 'GRC', id: 9 },
    { label: 'GRL', id: 10 },
    { label: 'GIN', id: 11 },
    { label: 'GNB', id: 12 },
    { label: 'NAM', id: 13 },
    { label: 'NRU', id: 14 },
    { label: 'NGA', id: 15 },
    { label: 'ATA', id: 16 },
    { label: 'SSD', id: 17 },
    { label: 'ZAF', id: 18 },
    { label: 'NLD', id: 19 },
    { label: 'ANT', id: 20 },
    { label: 'NPL', id: 21 },
    { label: 'NOR', id: 22 },
    { label: 'NFK', id: 23 },
    { label: 'NCL', id: 24 },
    { label: 'NZL', id: 25 },
    { label: 'NIU', id: 26 },
    { label: 'NER', id: 27 },
    { label: 'NIC', id: 28 },
    { label: 'KOR', id: 29 },
    { label: 'DNK', id: 30 },
    { label: 'DOM', id: 31 },
    { label: 'DMA', id: 32 },
    { label: 'DEU', id: 33 },
    { label: 'TLS', id: 34 },
    { label: 'LAO', id: 35 },
    { label: 'LBR', id: 36 },
    { label: 'LVA', id: 37 },
    { label: 'RUS', id: 38 },
    { label: 'LBN', id: 39 },
    { label: 'LSO', id: 40 },
    { label: 'REU', id: 41 },
    { label: 'ROU', id: 42 },
    { label: 'LUX', id: 43 },
    { label: 'RWA', id: 44 },
    { label: 'LBY', id: 45 },
    { label: 'LTU', id: 46 },
    { label: 'LIE', id: 47 },
    { label: 'MDG', id: 48 },
    { label: 'MTQ', id: 49 },
    { label: 'MHL', id: 50 },
    { label: 'MYT', id: 51 },
    { label: 'MAC', id: 52 },
    { label: 'MKD', id: 53 },
    { label: 'MWI', id: 54 },
    { label: 'MYS', id: 55 },
    { label: 'MLI', id: 56 },
    { label: 'IMN', id: 57 },
    { label: 'MEX', id: 58 },
    { label: 'MCO', id: 59 },
    { label: 'MAR', id: 60 },
    { label: 'MUS', id: 61 },
    { label: 'MRT', id: 62 },
    { label: 'MOZ', id: 63 },
    { label: 'MNE', id: 64 },
    { label: 'MSR', id: 65 },
    { label: 'MDA', id: 66 },
    { label: 'MDV', id: 67 },
    { label: 'MLT', id: 68 },
    { label: 'MNG', id: 69 },
    { label: 'USA', id: 70 },
    { label: 'UMI', id: 71 },
    { label: 'VIR', id: 72 },
    { label: 'MMR', id: 73 },
    { label: 'FSM', id: 74 },
    { label: 'VUT', id: 75 },
    { label: 'BHR', id: 76 },
    { label: 'BRB', id: 77 },
    { label: 'VAT', id: 78 },
    { label: 'BHS', id: 79 },
    { label: 'BGD', id: 80 },
    { label: 'BMU', id: 81 },
    { label: 'BEN', id: 82 },
    { label: 'VEN', id: 83 },
    { label: 'VNM', id: 84 },
    { label: 'BEL', id: 85 },
    { label: 'BLR', id: 86 },
    { label: 'BLZ', id: 87 },
    { label: 'BIH', id: 88 },
    { label: 'BWA', id: 89 },
    { label: 'BOL', id: 90 },
    { label: 'BDI', id: 91 },
    { label: 'BFA', id: 92 },
    { label: 'BVT', id: 93 },
    { label: 'BTN', id: 94 },
    { label: 'MNP', id: 95 },
    { label: 'BGR', id: 96 },
    { label: 'BRA', id: 97 },
    { label: 'BRN', id: 98 },
    { label: 'WSM', id: 99 },
    { label: 'SAU', id: 100 },
    { label: 'SGS', id: 101 },
    { label: 'SMR', id: 102 },
    { label: 'STP', id: 103 },
    { label: 'SPM', id: 104 },
    { label: 'ESH', id: 105 },
    { label: 'SEN', id: 106 },
    { label: 'SRB', id: 107 },
    { label: 'SYC', id: 108 },
    { label: 'LCA', id: 109 },
    { label: 'VCT', id: 110 },
    { label: 'KNA', id: 111 },
    { label: 'SHN', id: 112 },
    { label: 'SOM', id: 113 },
    { label: 'SLB', id: 114 },
    { label: 'SDN', id: 115 },
    { label: 'SUR', id: 116 },
    { label: 'LKA', id: 117 },
    { label: 'SJM', id: 118 },
    { label: 'SWZ', id: 119 },
    { label: 'SWE', id: 120 },
    { label: 'CHE', id: 121 },
    { label: 'ESP', id: 122 },
    { label: 'SVK', id: 123 },
    { label: 'SVN', id: 124 },
    { label: 'SYR', id: 125 },
    { label: 'SLE', id: 126 },
    { label: 'SGP', id: 127 },
    { label: 'ARE', id: 128 },
    { label: 'ABW', id: 129 },
    { label: 'ARM', id: 130 },
    { label: 'ARG', id: 131 },
    { label: 'ASM', id: 132 },
    { label: 'ISL', id: 133 },
    { label: 'HTI', id: 134 },
    { label: 'IRL', id: 135 },
    { label: 'AZE', id: 136 },
    { label: 'AFG', id: 137 },
    { label: 'AND', id: 138 },
    { label: 'ALB', id: 139 },
    { label: 'DZA', id: 140 },
    { label: 'AGO', id: 141 },
    { label: 'ATG', id: 142 },
    { label: 'AIA', id: 143 },
    { label: 'ERI', id: 144 },
    { label: 'EST', id: 145 },
    { label: 'ECU', id: 146 },
    { label: 'ETH', id: 147 },
    { label: 'SLV', id: 148 },
    { label: 'GBR', id: 149 },
    { label: 'VGB', id: 150 },
    { label: 'IOT', id: 151 },
    { label: 'YEM', id: 152 },
    { label: 'OMN', id: 153 },
    { label: 'AUS', id: 154 },
    { label: 'AUT', id: 155 },
    { label: 'HND', id: 156 },
    { label: 'ALA', id: 157 },
    { label: 'WLF', id: 158 },
    { label: 'JOR', id: 159 },
    { label: 'UGA', id: 160 },
    { label: 'URY', id: 161 },
    { label: 'UZB', id: 162 },
    { label: 'UKR', id: 163 },
    { label: 'IRQ', id: 164 },
    { label: 'IRN', id: 165 },
    { label: 'ISR', id: 166 },
    { label: 'EGY', id: 167 },
    { label: 'ITA', id: 168 },
    { label: 'IND', id: 169 },
    { label: 'IDN', id: 170 },
    { label: 'JPN', id: 171 },
    { label: 'JAM', id: 172 },
    { label: 'ZMB', id: 173 },
    { label: 'JEY', id: 174 },
    { label: 'GNQ', id: 175 },
    { label: 'PRK', id: 176 },
    { label: 'GEO', id: 177 },
    { label: 'CAF', id: 178 },
    { label: 'TWN', id: 179 },
    { label: 'CHN', id: 180 },
    { label: 'DJI', id: 181 },
    { label: 'GIB', id: 182 },
    { label: 'ZWE', id: 183 },
    { label: 'TCD', id: 184 },
    { label: 'CZE', id: 185 },
    { label: 'CHL', id: 186 },
    { label: 'CMR', id: 187 },
    { label: 'CPV', id: 188 },
    { label: 'KAZ', id: 189 },
    { label: 'QAT', id: 190 },
    { label: 'KHM', id: 191 },
    { label: 'CAN', id: 192 },
    { label: 'KEN', id: 193 },
    { label: 'CYM', id: 194 },
    { label: 'COM', id: 195 },
    { label: 'CRI', id: 196 },
    { label: 'CCK', id: 197 },
    { label: 'CIV', id: 198 },
    { label: 'COL', id: 199 },
    { label: 'COG', id: 200 },
    { label: 'COD', id: 201 },
    { label: 'CUB', id: 202 },
    { label: 'KWT', id: 203 },
    { label: 'COK', id: 204 },
    { label: 'HRV', id: 205 },
    { label: 'CXR', id: 206 },
    { label: 'KGZ', id: 207 },
    { label: 'KIR', id: 208 },
    { label: 'CYP', id: 209 },
    { label: 'THA', id: 210 },
    { label: 'TJK', id: 211 },
    { label: 'TZA', id: 212 },
    { label: 'TCA', id: 213 },
    { label: 'TUR', id: 214 },
    { label: 'TGO', id: 215 },
    { label: 'TKL', id: 216 },
    { label: 'TON', id: 217 },
    { label: 'TKM', id: 218 },
    { label: 'TUV', id: 219 },
    { label: 'TUN', id: 210 },
    { label: 'TTO', id: 221 },
    { label: 'PAN', id: 222 },
    { label: 'PRY', id: 223 },
    { label: 'PAK', id: 224 },
    { label: 'PNG', id: 225 },
    { label: 'PLW', id: 226 },
    { label: 'PSE', id: 227 },
    { label: 'FRO', id: 228 },
    { label: 'PER', id: 229 },
    { label: 'PRT', id: 230 },
    { label: 'FLK', id: 231 },
    { label: 'POL', id: 232 },
    { label: 'PRI', id: 233 },
    { label: 'FRA', id: 234 },
    { label: 'GUF', id: 235 },
    { label: 'ATF', id: 236 },
    { label: 'PYF', id: 237 },
    { label: 'FJI', id: 238 },
    { label: 'FIN', id: 239 },
    { label: 'PHL', id: 240 },
    { label: 'PCN', id: 241 },
    { label: 'HMD', id: 242 },
    { label: 'HUN', id: 243 },
    { label: 'HKG', id: 244 },
  ];

  export default countryCodeName;